const state = {
    clients: [],
    detailClient: [],
    loading: false,
};

export default state;